import { render, staticRenderFns } from "./FlagPills.vue?vue&type=template&id=86e7f314&scoped=true&"
import script from "./FlagPills.vue?vue&type=script&lang=js&"
export * from "./FlagPills.vue?vue&type=script&lang=js&"
import style0 from "./FlagPills.vue?vue&type=style&index=0&id=86e7f314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e7f314",
  null
  
)

export default component.exports